import QuotationDetail from "./QuotationDetail.container";

export default QuotationDetail;
